/**
 * @generated SignedSource<<e04b3d26d917efa6cb2f6980934c29ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AIChatContext_ChannelsFragment$data = {
  readonly chatChannels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly externalChannelId: string;
        readonly id: string;
        readonly isDefaultSuggestion: boolean;
      };
    }>;
  };
  readonly " $fragmentType": "AIChatContext_ChannelsFragment";
};
export type AIChatContext_ChannelsFragment$key = {
  readonly " $data"?: AIChatContext_ChannelsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AIChatContext_ChannelsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AIChatContext_ChannelsFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "chat_bot"
          ]
        }
      ],
      "concreteType": "ChatChannelNodeConnection",
      "kind": "LinkedField",
      "name": "chatChannels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatChannelNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatChannel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalChannelId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDefaultSuggestion",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "chatChannels(kinds:[\"chat_bot\"])"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "7252aa922afc06b319d259cd3e9d23f8";

export default node;
